import { gql } from "@apollo/client";

export const OrganizationMemberFragment = gql`
  fragment OrganizationMember on UserMemberNode {
    id
    user {
      id
      name
      firstName
      lastName
      avatar
      email
      status
      lastSeenStr
      primaryManager {
        id
      }
      managers {
        edges {
          node {
            id
            name
            avatar
          }
        }
      }
      teams {
        edges {
          node {
            id
            title
          }
        }
      }
      currentRoles {
        id
        title
        level
        careerTrack {
          id
          title
        }
      }
    }
    position
    role
    startDate
    employeeId
    jobLevel
    location
    membershipStatus
  }
`;

export default gql`
  ${OrganizationMemberFragment}
  query getOrganizationMembersQuery(
    $organizationId: Int!
    $after: String
    $managerId: Int
    $showAdminsOnly: Boolean
    $search: String = ""
    $teamId: Int
    $orderBy: String
    $membershipStatus: AccountToOrganizationMembershipStatus
  ) {
    organization(pk: $organizationId) {
      id
      members(
        first: 20
        after: $after
        search: $search
        orderBy: $orderBy
        isAdmin: $showAdminsOnly
        membershipStatus: $membershipStatus
        teamId: $teamId
        managerId: $managerId
      ) {
        totalCount
        pageInfo {
          endCursor
          hasNextPage
        }
        edges {
          node {
            ...OrganizationMember
          }
        }
      }
    }
  }
`;
